jQuery(document).ready(function ($) {
  'use strict';

  function initHomeHeroBgSliders(context) {
	var $scope = context ? $(context) : $(document);

	$scope.find('.js-hero-bg-slider').each(function () {
	  var $slider = $(this);

	  if ($slider.hasClass('slick-initialized')) return;

	  $slider.slick({
		arrows: false,
		dots: false,
		infinite: true,
		fade: true,
		speed: 900,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		pauseOnFocus: false,
		accessibility: true,
		adaptiveHeight: false,
		draggable: false,
		swipe: false,
		touchMove: false
	  });
	});
  }

  initHomeHeroBgSliders(document);

  // Optional: re-init after AJAX/render updates
  $(document).on('sb:init-hero-sliders', function (e, container) {
	initHomeHeroBgSliders(container || document);
  });
});


// STICKY CLASSES
jQuery(document).ready(function ($) {

  function sbHeaderStates() {
	var y = $(window).scrollTop();

	// sticky after 1px
	if (y > 1) {
	  $('.sb-header').addClass('sticky');
	} else {
	  $('.sb-header').removeClass('sticky');
	}

	// thin after 150px
	if (y > 150) {
	  $('.sb-header').addClass('thin');
	} else {
	  $('.sb-header').removeClass('thin');
	}
  }

  // run once on load (handles refresh mid-page)
  sbHeaderStates();

  // run on scroll
  $(window).on('scroll', sbHeaderStates);

});


// ALERT BANNER
jQuery(document).ready(function ($) {
	'use strict';

	function updateHeaderTop() {
		var $banner = $('.alert-banner-top');
		var bannerHeight = $banner.outerHeight() || 0;
		var scrollTop = $(window).scrollTop();

		var topOffset = Math.max(30, bannerHeight + 30 - scrollTop);

		document.documentElement.style.setProperty('--header-top', topOffset + 'px');
	}

	updateHeaderTop();

	$(window).on('scroll resize', updateHeaderTop);
});

// BUTTON ARROWS
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.alert-banner-top p a').forEach(function(link) {
	if (!link.querySelector('.fa-arrow-right')) {
	  const icon = document.createElement('i');
	  icon.className = 'fa-utility fa-semibold fa-arrow-right';
	  icon.style.marginLeft = '3px';
	  link.appendChild(icon);
	}
  });
});

// GCI HERO SHAPE
jQuery(function ($) {
	'use strict';

	function updateGciHeroShapes() {
		$('.gci-hero-area').each(function () {
			var $area = $(this);
			var $shape = $area.find('.gci-hero-shape');
			var $path = $area.find('.gci-hero-clip-path');

			if (!$shape.length || !$path.length) {
				return;
			}

			var width = Math.round($shape.outerWidth());
			var height = Math.round($shape.outerHeight());

			if (!width || !height) {
				return;
			}

			var radius = window.matchMedia('(max-width: 992px)').matches ? 50 : 100;

			// Prevent the shape from breaking on very small/tight areas.
			radius = Math.min(radius, width / 3, height / 3);

			var r = radius;
			var w = width;
			var h = height;

			/*
				Shape logic:

				Top-left: square
				Top-right: square
				Bottom-left: normal rounded curve
				Bottom-right: outward/reverse curve

				The main bottom edge sits at h - r.
				The bottom-right curve drops outward down to h.
			*/

			var d = [
				'M 0 0',
				'H ' + w,
				'V ' + h,

				// Bottom-right outward curve.
				'C ' + w + ' ' + (h - (r * 0.5523)) + ', ' + (w - (r * 0.4477)) + ' ' + (h - r) + ', ' + (w - r) + ' ' + (h - r),

				// Bottom horizontal edge.
				'H ' + r,

				// Bottom-left rounded curve.
				'C ' + (r * 0.4477) + ' ' + (h - r) + ', 0 ' + (h - (r * 1.4477)) + ', 0 ' + (h - (r * 2)),

				'V 0',
				'Z'
			].join(' ');

			$path.attr('d', d);
		});
	}

	updateGciHeroShapes();

	$(window).on('load resize orientationchange', function () {
		updateGciHeroShapes();
	});
});



// BUTTON ARROWS
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.arrow-btn').forEach(function(el) {
	if (!el.querySelector('.fa-right-long')) {
	  const icon = document.createElement('i');
	  icon.className = 'fa-sharp fa-solid fa-right-long';
	  icon.style.marginLeft = '0.3em';
	  el.appendChild(icon);
	}
  });
});

// FAQ
jQuery(function ($) {
	'use strict';

	$('.pm__faq').each(function () {
		var $accordion = $(this);

		$accordion.on('click', '.pm__faq-q', function () {
			var $button = $(this);
			var $item = $button.closest('.pm__faq-item');
			var $panel = $item.find('.pm__faq-panel').first();
			var isOpen = $button.attr('aria-expanded') === 'true';

			// Close all other items in this accordion.
			$accordion
				.find('.pm__faq-item')
				.not($item)
				.removeClass('is-open')
				.find('.pm__faq-q')
				.attr('aria-expanded', 'false');

			$accordion
				.find('.pm__faq-panel')
				.not($panel)
				.stop(true, true)
				.slideUp(250, function () {
					$(this).attr('hidden', true);
				});

			// Toggle the selected item.
			if (isOpen) {
				$item.removeClass('is-open');
				$button.attr('aria-expanded', 'false');

				$panel.stop(true, true).slideUp(250, function () {
					$(this).attr('hidden', true);
				});
			} else {
				$item.addClass('is-open');
				$button.attr('aria-expanded', 'true');

				$panel
					.removeAttr('hidden')
					.stop(true, true)
					.hide()
					.slideDown(250);
			}
		});
	});
});

// PAGE IMAGE SLIDER
jQuery(function ($) {
	'use strict';

	$('.js-pm-image-slider').each(function (index) {
		var $slider = $(this);

		if ($slider.hasClass('slick-initialized')) {
			return;
		}

		var slideCount = $slider.children('.pm__image-slide').length;
		var sliderLabel = $slider.data('slider-label') || 'Image gallery';

		// A single image does not need carousel controls.
		if (slideCount < 2) {
			$slider.addClass('is-static');
			return;
		}

		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			adaptiveHeight: true,
			arrows: true,
			dots: true,
			autoplay: false,
			speed: 500,
			swipeToSlide: true,

			regionLabel: sliderLabel + ' ' + (index + 1),
			instructionsText: 'Use the previous and next buttons to browse the images.',
			useGroupRole: true,

			prevArrow:
				'<button type="button" class="slick-prev pm__slider-arrow pm__slider-arrow--prev">' +
					'<span class="visually-hidden">Previous image</span>' +
					'<i class="fa-sharp fa-solid fa-left-long" aria-hidden="true"></i>' +
				'</button>',

			nextArrow:
				'<button type="button" class="slick-next pm__slider-arrow pm__slider-arrow--next">' +
					'<span class="visually-hidden">Next image</span>' +
					'<i class="fa-sharp fa-solid fa-right-long" aria-hidden="true"></i>' +
				'</button>'
		});
	});
});


// SIDEBAR H3 ICON
(function () {
  function injectSidebarIcons() {
	var headings = document.querySelectorAll('.wordpress-sidebar h3');

	headings.forEach(function (h3) {
	  // Duplicate guard — survives FA's <i> → <svg> swap
	  if (h3.dataset.iconInjected) return;

	  var icon = document.createElement('i');
	  icon.className = 'fa-sharp fa-solid fa-link sidebar-h3-icon';
	  icon.setAttribute('aria-hidden', 'true');

	  // icon, then a space, before the existing heading text
	  h3.prepend(icon, ' ');

	  h3.dataset.iconInjected = 'true';
	});
  }

  if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', injectSidebarIcons);
  } else {
	injectSidebarIcons();
  }
})();


/**
 * Blog grid — AJAX category filter + pagination.
 * Paste into the theme's JS file. Reads config from data attributes on #blog-grid.
 */
( function () {
	'use strict';

	function sbBlogFilterInit() {

		var wrap = document.getElementById( 'blog-grid' );

		if ( ! wrap ) {
			return;
		}

		var select     = document.getElementById( 'blog-filter-category' );
		var results    = document.getElementById( 'blog-grid-results' );
		var pagination = document.getElementById( 'blog-grid-pagination' );

		if ( ! select || ! results || ! pagination ) {
			return;
		}

		var base    = wrap.getAttribute( 'data-base' ) || window.location.href.split( '?' )[0];
		var ajaxUrl = wrap.getAttribute( 'data-ajax' ) || '/wp-admin/admin-ajax.php';
		var nonce   = wrap.getAttribute( 'data-nonce' ) || '';
		var request = null;

		function getPageFromLink( link ) {
			var href = link.getAttribute( 'href' ) || '';

			var pretty = href.match( /\/page\/(\d+)/ );
			if ( pretty ) {
				return parseInt( pretty[1], 10 );
			}

			var query = href.match( /[?&]paged?=(\d+)/ );
			if ( query ) {
				return parseInt( query[1], 10 );
			}

			var text = parseInt( link.textContent.replace( /\D/g, '' ), 10 );
			return isNaN( text ) ? 1 : text;
		}

		function buildUrl( category, paged ) {
			var url = base.replace( /\/$/, '' ) + '/';

			if ( paged > 1 ) {
				url += 'page/' + paged + '/';
			}

			if ( category && parseInt( category, 10 ) > 0 ) {
				url += '?cat=' + category;
			}

			return url;
		}

		function load( category, paged, scroll ) {

			if ( request ) {
				request.abort();
			}

			wrap.classList.add( 'is-loading' );
			results.setAttribute( 'aria-busy', 'true' );

			var data = new FormData();
			data.append( 'action', 'sb_blog_filter' );
			data.append( 'nonce', nonce );
			data.append( 'category', category );
			data.append( 'paged', paged );
			data.append( 'base', base );

			request = new XMLHttpRequest();
			request.open( 'POST', ajaxUrl, true );

			request.onload = function () {
				var response;

				wrap.classList.remove( 'is-loading' );
				results.setAttribute( 'aria-busy', 'false' );

				try {
					response = JSON.parse( request.responseText );
				} catch ( e ) {
					request = null;
					return;
				}

				request = null;

				if ( ! response || ! response.success ) {
					return;
				}

				results.innerHTML    = response.data.grid;
				pagination.innerHTML = response.data.pagination;

				if ( window.history && window.history.pushState ) {
					window.history.pushState(
						{ cat: category, paged: paged },
						'',
						buildUrl( category, paged )
					);
				}

				if ( scroll ) {
					wrap.scrollIntoView( { behavior: 'smooth', block: 'start' } );
				}
			};

			request.onerror = function () {
				wrap.classList.remove( 'is-loading' );
				results.setAttribute( 'aria-busy', 'false' );
				request = null;
			};

			request.send( data );
		}

		select.addEventListener( 'change', function () {
			load( this.value, 1, false );
		} );

		pagination.addEventListener( 'click', function ( event ) {
			var link = event.target.closest( 'a' );

			if ( ! link || ! pagination.contains( link ) ) {
				return;
			}

			event.preventDefault();
			load( select.value, getPageFromLink( link ), true );
		} );

		window.addEventListener( 'popstate', function ( event ) {
			if ( ! event.state ) {
				return;
			}

			select.value = event.state.cat;
			load( event.state.cat, event.state.paged, false );
		} );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', sbBlogFilterInit );
	} else {
		sbBlogFilterInit();
	}

}() );


// RESPONSIVE VIDEO GEN CONT
jQuery(document).ready(function($) {
/* Embedded Videos */
var $embedded_videos = $('.gen-cont iframe');
$embedded_videos.each(function(e) {
	var $this = $(this),
		attr = $this.attr('src');
	console.log(attr);
	if ( attr.indexOf( 'youtu' ) !== -1 || attr.indexOf( 'vimeo' ) !== -1 ) {
		$this.wrap('<div class="video-wrapper"></div>');
	}
});
});